<template>
  <MeniuNavigare />
  <router-view :key="this.$route.path" />
</template>

<script>
import Vuex from "vuex"
import MeniuNavigare from '@/components/MeniuNavigare.vue'

export default {
  name: 'App',
  components: {
    MeniuNavigare
  },
  data(){
    return {
      
    }
  },
  computed:{
    ...Vuex.mapState(['cards', 'loading', 'filter', 'filter_type', 'filter_categorie']),
    ...Vuex.mapGetters(['CardsList']),
  },
  mounted(){
    try{
      this.$store.dispatch('loadCards');
    }
    catch(Err){
      console.log(Err)
    }
  },
}
</script>

<style scoped>

</style>
